import React, { useEffect, useState, useCallback } from "react";
import PropTypes from "prop-types";
import Card from "../../components/Cards/Card";
import { useSelections } from "../../context/Selections";
import styled from "styled-components";
import NativeObject from "../../components/NativeObject/NativeObject";

import KpiCard from "../../components/KpiCard/KpiCard";

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "flex-start",
  width: "100%",
});

const LayoutCardWrapper = styled.div`
  border-radius: 16px;
  display: flex;
  width: 100%;
  height: 100%;
  padding: 10px;
  flex-direction: column;
`;

function ResumoDesktop({ app, config }) {
  const [namePeriodo, setNamePreiodo] = useState();

  const [numberCard1, setNumberCard1] = useState();
  const [numberCard2, setNumberCard2] = useState();
  const [numberCard3, setNumberCard3] = useState();
  const [numberCard4, setNumberCard4] = useState();

  const { selections } = useSelections();

  const getNumberforBigNumbers = useCallback(
    async (objectId, index) => {
      if (app && objectId) {
        let id = objectId;
        await app.visualization.get(id).then((res) => {
          const value =
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qText ??
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qNum ??
            null;
          index === 1 && setNumberCard1(value);
          index === 2 && setNumberCard2(value);
          index === 3 && setNumberCard3(value);
          index === 4 && setNumberCard4(value);
        });
      }
    },
    [app]
  );

  const transformObjectValueInString = useCallback(
    async (objectId) => {
      if (app && objectId) {
        let id = objectId;
        await app.visualization.get(id).then((res) => {
          const value =
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qText ??
            res?.model?.layout?.qHyperCube?.qGrandTotalRow[0]?.qNum ??
            null;
          setNamePreiodo(value);
        });
      }
    },
    [app, selections]
  );

  useEffect(() => {
    if (app) {
      transformObjectValueInString("vvkXXx");
      getNumberforBigNumbers("JbfREag", 1);
      getNumberforBigNumbers("XwXpd", 2);
      getNumberforBigNumbers("agRSzn", 3);
      getNumberforBigNumbers("FCRYn", 4);
    }
  }, [
    namePeriodo,
    app,
    transformObjectValueInString,
    selections,
    getNumberforBigNumbers,
  ]);
  return (
    <div className="app resumo">
      <div className="appContent">
        <LayoutCardsWrapper>
          <LayoutCardWrapper>
            <div className="container-titles">
              <h3>Resumo</h3>

              <p>
                <span>Período analisado</span>
                <span className="name-periodo-analisado">{namePeriodo}</span>
              </p>
            </div>

            <div className="group-cards">
              <div className="adm-cards">
                <Card
                  app={app}
                  header={{
                    hardTitle: "Pontuação Total",
                  }}
                  className={"container-card-item"}
                >
                  <div className="informativo-kpis informativo-one"></div>
                  <div className="container-object-and-icon">
                    <p className={"container-card-item-object"}>
                      {numberCard1} <span>pontos</span>
                    </p>
                  </div>
                </Card>

                <Card
                  app={app}
                  header={{
                    hardTitle: "KPIs Estruturais",
                  }}
                  className={"container-card-item"}
                >
                  <div className="informativo-kpis informativo-two"></div>

                  <div className="container-object-and-icon">
                    <p className={"container-card-item-object"}>
                      {numberCard2} <span>pontos</span>
                    </p>
                  </div>
                </Card>

                <Card
                  app={app}
                  header={{
                    hardTitle: "KPIs de Performance",
                  }}
                  className={"container-card-item"}
                >
                  <div className="informativo-kpis  informativo-three"></div>
                  <div className="container-object-and-icon">
                    <p className={"container-card-item-object"}>
                      {numberCard3} <span>pontos</span>
                    </p>
                  </div>
                </Card>

                <Card
                  app={app}
                  className={"container-card-item container-card-item-kpi"}
                >
                  <div className="informativo-kpis  informativo-foor"></div>
                  <KpiCard
                    KPITitle={"Gatilho de Jameson"}
                    app={app}
                    valueId={"hYhtVg"}
                    goalValueId={"GKcTPD"}
                    percentageId={"phkAXr"} // no enter
                    hasProgressBar={true}
                    fullView
                  ></KpiCard>
                </Card>
              </div>
            </div>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "18px",
                height: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  height: "100%",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  gap: "16px",
                }}
                className="container-line"
              >
                <Card
                  app={app}
                  header={{
                    hardTitle: "Pontos por Trimestre - Performance",
                  }}
                  style={{ height: "100%" }}
                  className="container-card"
                >
                  <div className="container-legendas">
                    <div className="item-legenda">
                      <span className="color-legenda color-one" />
                      <span>Pontos Possíveis</span>
                    </div>
                    <div className="item-legenda">
                      <span className="color-legenda color-two" />
                      <span>Pontos Realizados</span>
                    </div>
                  </div>
                  <NativeObject
                    app={app}
                    key="pHFUBHy"
                    reference={{ id: "pHFUBHy" }}
                    className={"quadrimestre-overview"}
                  />
                </Card>

                <Card
                  app={app}
                  header={{
                    hardTitle: "Pontos por KPIs",
                  }}
                  style={{ height: "100%" }}
                  className="container-card"
                >
                  <div className="container-legendas">
                    <div className="item-legenda">
                      <span className="color-legenda color-two-kpi" />
                      <span className="legenda-text">KPIs Estruturais</span>
                    </div>

                    <div className="item-legenda">
                      <span className="color-legenda color-one-kpi" />
                      <span className="legenda-text">KPIs de Performance</span>
                    </div>
                  </div>
                  <NativeObject
                    app={app}
                    key="KgAuTJ"
                    reference={{ id: "KgAuTJ" }}
                    className={"quadrimestre-overview"}
                  />
                </Card>
              </div>

              <div
                style={{
                  display: "flex",
                  width: "100%",
                  height: "100%",
                  alignItems: "center",
                  justifyContent: "flex-start",
                  gap: "16px",
                }}
                className="container-line"
              >
                <Card
                  app={app}
                  header={{
                    hardTitle: "Pontos por KPIs de Performance",
                  }}
                  style={{ height: "100%" }}
                  className="container-card"
                >
                  <div className="container-legendas">
                    <div className="item-legenda">
                      <span className="color-legenda color-one" />
                      <span>Pontos Possíveis</span>
                    </div>
                    <div className="item-legenda">
                      <span className="color-legenda color-two" />
                      <span>Pontos Realizados</span>
                    </div>
                  </div>
                  <NativeObject
                    app={app}
                    key="qaVAynq"
                    reference={{ id: "qaVAynq" }}
                    className={"quadrimestre-overview"}
                  />
                </Card>

                <Card
                  app={app}
                  header={{
                    hardTitle: "Pontos por KPIs Estruturais",
                  }}
                  style={{ height: "100%" }}
                  className="container-card"
                >
                  <div className="container-legendas">
                    <div className="item-legenda">
                      <span className="color-legenda color-one" />
                      <span>Pontos Possíveis</span>
                    </div>
                    <div className="item-legenda">
                      <span className="color-legenda color-two" />
                      <span>Pontos Realizados</span>
                    </div>
                  </div>
                  <NativeObject
                    app={app}
                    key="YwyYUh"
                    reference={{ id: "YwyYUh" }}
                    className={"quadrimestre-overview"}
                  />
                </Card>
              </div>
            </div>
          </LayoutCardWrapper>
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

ResumoDesktop.defaultProps = {
  app: null,
  config: {},
};

ResumoDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default ResumoDesktop;
